import React, {
	useCallback,
	useContext,
	useEffect,
	useState,
	useRef,
} from 'react';

// ANTD
import {
	Row,
	Col,
	Upload as AntUpload,
	Button as AntButton,
	message as AntMessage,
	Modal,
} from 'antd';

// ROUTES
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTE_IIRGD } from 'routes/paths';
import {
	ROUTE_IIRGD_PESQUISAR_RG,
	ROUTE_IIRGD_INCLUSAO_OBSERVACOES,
	ROUTE_IIRGD_DIVERGENCIAS,
} from 'pages/iirgd/RgFicDigital/routes/paths';

// REDUX
import data from 'store/modules/api/iirgd/enum';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
	addNotifications,
	clearNotifications,
} from 'store/modules/app/notifications/actions';
import { consultarCpfClear } from 'store/modules/api/rfb/consultarCpf/actions';
import { consultaCpfClear } from 'store/modules/api/iirgd/pesquisaCicp/actions';
import { consultaPesquisaCriminalClear } from 'store/modules/api/iirgd/consultaPesquisaCriminal/actions';
import {
	cadastroRgOriginal,
	cadastrarRgRequest,
	atualizarRgRequest,
	cadastroRgClear,
	cadastroRgConfirmacaoAtendimento,
	cadastrarRgSuccess,
	atualizarRgSuccess,
	cadastroRgSegundaVia,
	cadastroRgPrimeiraVia,
} from 'store/modules/api/iirgd/cadastroRg/actions';
import { consultaPesquisaCidadaoClear } from 'store/modules/api/iirgd/consultaPesquisaCidadao/actions';
import {
	consultaPesquisaObservacaoRequest,
	consultaPesquisaObservacaoClear,
} from 'store/modules/api/iirgd/consultaPesquisaObservacao/actions';
import { disponibilzarDareClear } from 'store/modules/api/potencial/disponibilzarDare/actions';
import {
	dareKitRequest,
	gerarDareClear,
} from 'store/modules/api/gerarDare/actions';
import { setBreadcrumb } from 'store/modules/app/breadcrumb/actions';
import { geraSenhaClear } from 'store/modules/api/relatorios/geraSenha/actions';
import {
	consultarCpfCinResponsavelClear,
	consultarCpfCinResponsavelRequest,
} from 'store/modules/api/iirgd/integrador/consultarCpfCinResponsavel/actions';

// COMPONENTS COMMON
import Section from 'components/Common/Section';
import ButtonImage from 'components/Common/ButtonImage';
import ButtonVoltar from 'components/Common/ButtonVoltar';

// UTILS
import { getFormValidationsErrors } from 'utils/getValidationsErrors';
import {
	calcularIdade,
	completaZeroEsquerda,
	formatDate,
	limparMascara,
	unformatDate,
} from 'utils/genericFunctions';
import { letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos } from 'utils/stringFunctions';
import { scrollToTopByClassName } from 'utils/scrollFunctions';

// COMPONENTS
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce';
import { OptionProps } from 'components/Common/Form/Select';
import { Form, Formik } from 'formik';
import {
	ANEXAR_DOC_DA_DIVERGENCIA_CPF,
	HABILITA_MULTIFILIACAO,
	HABILITA_CADASTRO_CIPTEA,
} from 'store/modules/api/sgu/loginUnico/constants';
import { ParametrosLocalidade } from 'store/modules/api/sgu/loginUnico/types';
import {
	consultarProcessoClear,
	consultarProcessoRequest,
} from 'store/modules/api/iirgd/integrador/consultarProcesso/actions';
import { estatisticaIncluirRequest } from 'store/modules/api/sguService/estatisticasIncluir/actions';
import { IncluirRequest } from 'store/modules/api/sguService/estatisticasIncluir/types';
import {
	consultarCpfCinClear,
	consultarCpfCinRequest,
} from 'store/modules/api/iirgd/integrador/consultarCin/actions';
import { getApiIntegrador } from 'services/_sgu';
import { capturarBiometriaClearLeitura } from 'store/modules/api/biometria/capturarBiometria/actions';
import { completarCPF } from 'utils/numberFunctions';
import {
	cadastraDocumentosRequest,
	limpaCadastraDocumentos,
} from 'store/modules/api/iirgd/cadastraDocumentos/actions';
import { consultaDocumentosRequest } from 'store/modules/api/iirgd/consultaDocumentos/actions';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {
	baixarArquivosClear,
	baixarArquivosRequest,
} from 'store/modules/api/utils/arquivos/baixarArquivos/actions';
import PDFViewer from 'components/Common/PDFViewer';
import { treatPathBaseIntegradorUrl } from 'services/rotasp/utils/paths/treatPaths';
import { PATH_ARQUIVOS_API } from 'services/rotasp/path';
import { Naturalidade } from 'store/modules/api/sgu/administrar/naturalidades/consultarNaturalidades/types';
import { CINValidationMessages } from './utils/messages/cin';
import {
	getDescricaoSituationCin,
	verifyCinProccesses,
} from './utils/validations/cin';
import Principal from './Sections/Principal';
import DocumentoApresentado from './Sections/DocumentoApresentado';
import DadosAdicionaisCidadao from './Sections/DadosAdicionais/Cidadao';
import DadosAdicionaisTrabalho from './Sections/DadosAdicionais/Trabalho';
import DadosAdicionaisContato from './Sections/DadosAdicionais/Contato';
import DadosAdicionaisRG from './Sections/DadosAdicionais/RG';
import InfosAdicionais from './Sections/InfosAdicionais';
import EntregaRG from './Sections/EntregaRG';

// FORM
import {
	initialValues as initialValuesForm,
	schema,
	IFormCadastroRg,
} from './form';

// MODAL
import SolicitarInscricaoCPF from './Modal/SolicitarInscricaoCPF';
import ConfirmacaoAtendimento from './Modal/ConfirmacaoAtendimento';
import { cidValuesCIPTEA } from './Modal/CadastroCIPTEA/form';

const CadastroRG: React.FC = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();

	const [uploadedFileUrlForDivergence, setUploadedFileUrlForDivergence] =
		useState<string>('');
	const [uploadedNameDivergence, setUploadedNameDivergence] =
		useState<string>('');
	const [uploadDivergenceError, setUploadDivergenceError] = useState<
		string | null
	>(null);
	const [isUploadingDivergenceFile, setIsUploadingDivergenceFile] =
		useState<boolean>(false);
	const [divergenceAntdFileList, setDivergenceAntdFileList] = useState<any[]>(
		[],
	);

	const { token } = useContext<IAuthContext>(AuthContext);

	const [formInitialValues, setFormInitialValues] =
		useState<IFormCadastroRg>(initialValuesForm);

	const { login } = useSelector(
		(state: ApplicationState) => state.api.sgu.loginUnico,
	);

	const {
		cadastroRg,
		consultaPesquisaCirg,
		consultaPesquisaCidadao,
		consultaPesquisaObservacao,
	} = useSelector((state: ApplicationState) => state.api.iirgd);

	const { primeiraVia, reusoParcial, reusoTotal, segundaVia } = useSelector(
		(state: ApplicationState) => state.api.iirgd.cadastroRg.tipo,
	);

	const consultaDocumentosData = useSelector(
		(state: ApplicationState) => state.api.iirgd.consultaDocumentos.data,
	);

	const statusDocumentos = useSelector(
		(state: ApplicationState) => state.api.iirgd.cadastraDocumentos.status,
	);

	const { notifications } = useSelector((state: ApplicationState) => state.app);

	const cpfStatus = useSelector(
		(state: ApplicationState) => state.api.iirgd.integrador.consultarCin,
	);

	const { consultarCin, consultarCpfCinResponsavel, consultarProcesso } =
		useSelector((state: ApplicationState) => state.api.iirgd.integrador);

	const { loginUnico, atendimento } = useSelector(
		(state: ApplicationState) => state.api.sgu,
	);

	const [checkResponsavel, setCheckResponsavel] = useState<boolean>(false);

	const [cadastraRG, setCadastraRg] = useState<boolean>(false);

	const [caller1, setCaller1] = useState<number>(0);
	const [caller2, setCaller2] = useState<number>(0);

	const [hasSubmit, setHasSubmit] = useState<boolean>(false);
	const [hasLoaded, setHasLoaded] = useState<boolean>(false);
	const [appTitle, setAppTitle] = useState<string>('');

	const [formValues, setFormValues] = useState<IFormCadastroRg | null>(null);

	const [modalInscricaoCpf, setModalInscricaoCpf] = useState<boolean>(false);
	const [modalAtendimento, setModalAtendimento] = useState<boolean>(false);
	const [erroCIN, setErroCIN] = useState<boolean>(false);

	const [bloqueioPortaria606, setBloqueioPortaria606] =
		useState<boolean>(false);

	const [rfbDivergenceData, setRfbDivergenceData] = useState<any>(null);

	const { baixarArquivos } = useSelector(
		(state: ApplicationState) => state.api.utils,
	);

	const modalInstanceRef = useRef<any>(null);
	const modalCreationArgsRef = useRef<any | null>(null);

	const verifyUpload = useCallback(() => {
		let isAllowed = false;
		loginUnico.login.user.parametrosLocalidade.forEach(
			(item: ParametrosLocalidade) => {
				if (
					item.sigla.toLowerCase() ===
						ANEXAR_DOC_DA_DIVERGENCIA_CPF.toLowerCase() &&
					item.valor.toLowerCase() === 'true'
				) {
					isAllowed = true;
				}
			},
		);
		return isAllowed;
	}, [loginUnico.login.user.parametrosLocalidade]);

	const verifyCipteaEnabled = useCallback(() => {
		return loginUnico.user.parametrosSistema.some(
			(item: ParametrosLocalidade) =>
				item.sigla.toLowerCase() === HABILITA_CADASTRO_CIPTEA.toLowerCase() &&
				item.valor.toLowerCase() === 'true',
		);
	}, [loginUnico.user.parametrosSistema]);

	const verifyCIDHasCIPTEA = (
		cid1: string,
		cid2: string,
		cid3: string,
		cid4: string,
	) => {
		return (
			(cid1 && cidValuesCIPTEA.includes(cid1.toUpperCase())) ||
			(cid2 && cidValuesCIPTEA.includes(cid2.toUpperCase())) ||
			(cid3 && cidValuesCIPTEA.includes(cid3.toUpperCase())) ||
			(cid4 && cidValuesCIPTEA.includes(cid4.toUpperCase())) ||
			false
		);
	};

	useEffect(() => {
		setBloqueioPortaria606(
			cadastroRg.config?.novo === false &&
				cadastroRg.config?.acervo === false &&
				cadastroRg.portaria606 === true,
		);
	}, [cadastroRg, consultaPesquisaCidadao]);

	useEffect(() => {
		dispatch(geraSenhaClear());
		dispatch(baixarArquivosClear());
	}, [dispatch]);

	useEffect(() => {
		if (cadastroRg.info.lote && cadastroRg.info.lote.indexOf('2') !== -1) {
			dispatch(cadastroRgSegundaVia());
		} else if (cadastroRg.info.lote) {
			dispatch(cadastroRgPrimeiraVia());
		}
	}, [dispatch, cadastroRg.info.lote]);

	// Reseta o "sucesso" no envio do cadastro/atualização do RG.
	// Isso força a reenviar os dados para o serviço.
	useEffect(() => {
		if (!hasSubmit) {
			dispatch(cadastrarRgSuccess(false));
			dispatch(atualizarRgSuccess(false));

			dispatch(consultaPesquisaObservacaoClear());
			dispatch(consultarCpfCinClear());
			dispatch(consultarCpfCinResponsavelClear());
			dispatch(limpaCadastraDocumentos());
		}
	}, [hasSubmit, dispatch]);

	useEffect(() => {
		scrollToTopByClassName('ant-breadcrumb');
	}, [dispatch]);

	useEffect(() => {
		if (
			hasSubmit &&
			(cadastroRg.cadastrarRgSuccess || cadastroRg.atualizarRgSuccess) &&
			cadastroRg.form.principal
		) {
			dispatch(consultarCpfClear());
			if (
				cadastroRg.form.principal &&
				typeof cadastroRg.form.principal.entrega === 'number'
			) {
				dispatch(
					dareKitRequest({
						quantidade: cadastroRg.form.principal.entrega,
					}),
				);
			}

			const isCipteaEnabled = verifyCipteaEnabled();
			const isUploadEnabled = verifyUpload();
			const isPrimeiraViaFlow = primeiraVia;

			const { cid1, cid2, cid3, cid4, divergenciaRfb } =
				cadastroRg.form.principal;

			const hasCipteaCid = verifyCIDHasCIPTEA(cid1, cid2, cid3, cid4);
			// const isUnder16 = dataNascimento
			// 	? calcularIdade(dataNascimento) < 16
			// 	: false;
			const hasCPFDivergences =
				!!consultarCin.data &&
				consultarCin.data.codSitCad !== '0' &&
				consultarCin.data.codSitCad !== '4';
			const shouldShowCiptea = isCipteaEnabled && hasCipteaCid;
			const shouldShowDivergence =
				(hasCPFDivergences || divergenciaRfb) &&
				isPrimeiraViaFlow &&
				isUploadEnabled;

			if (shouldShowCiptea || shouldShowDivergence) {
				history.push(ROUTE_IIRGD_DIVERGENCIAS, {
					showCiptea: shouldShowCiptea,
					showDivergence: shouldShowDivergence,
					formData: cadastroRg.form.principal,
					originalData: cadastroRg.original,
					consultarCinData: consultarCin.data,
				});
			} else {
				history.push(ROUTE_IIRGD_INCLUSAO_OBSERVACOES);
			}

			dispatch(cadastrarRgSuccess(false));
			dispatch(atualizarRgSuccess(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		cadastroRg.cadastrarRgSuccess,
		cadastroRg.atualizarRgSuccess,
		cadastroRg.form.principal,
		cadastroRg.original,
		dispatch,
		hasSubmit,
		history,
		primeiraVia,
		verifyCipteaEnabled,
		verifyUpload,
	]);

	// Pesquisa de Observação (realizada ao atualizar o RG - Segunda via).
	useEffect(() => {
		if (hasSubmit && formValues && cadastroRg.atualizarRgSuccess)
			dispatch(
				consultaPesquisaObservacaoRequest(token, {
					numeroRg: formValues.numeroRg,
					usuario: login.mainframe.idUsuario,
					senha: login.mainframe.senhaMainFrame,
				}),
			);
	}, [
		hasSubmit,
		cadastroRg.atualizarRgSuccess,
		dispatch,
		formValues,
		login.mainframe,
		token,
	]);

	useEffect(() => {
		if (
			consultaPesquisaObservacao.result &&
			cadastroRg.atualizarRgSuccess &&
			cadastroRg.form.principal
		) {
			if (
				cadastroRg.form.principal &&
				typeof cadastroRg.form.principal.entrega === 'number'
			) {
				dispatch(
					dareKitRequest({ quantidade: cadastroRg.form.principal.entrega }),
				);
			}
		}
	}, [
		cadastroRg.atualizarRgSuccess,
		cadastroRg.form.principal,
		consultaPesquisaObservacao,
		dispatch,
	]);

	const handleClearTypeDocumentNC = useCallback((values: IFormCadastroRg) => {
		if (values.dbas === 'NC') {
			values.dbas = '';
			values.comarca = '';
			values.cartorio = '';
			values.livro = '';
			values.folha = '';
			values.numero = '';
			values.dataDocumento = '';
		}
	}, []);

	const verifyLocationIsAllowedMultifiliacao = useCallback(() => {
		let isAllowed = false;
		loginUnico.user.parametrosSistema.forEach((item: ParametrosLocalidade) => {
			if (
				item.sigla.toLowerCase() === HABILITA_MULTIFILIACAO.toLowerCase() &&
				item.valor.toLowerCase() === 'true'
			) {
				isAllowed = true;
			}
		});
		return isAllowed;
	}, [loginUnico.user.parametrosSistema]);

	// Preenchimento do formulário (Primeira via / Segunda via).
	useEffect(() => {
		if (!hasLoaded) {
			if (cadastroRg.config?.novo) {
				setAppTitle(`Cadastrar Carteira de Identidade`);
			} else if (cadastroRg.config?.acervo) {
				setAppTitle('Cadastrar Carteira de Identidade Acervo');
			} else if (cadastroRg.config?.edicao) {
				setAppTitle('Editar Cadastro');
				if (
					cadastroRg.form.principal?.numeroRg &&
					cadastroRg.form.principal?.cpf &&
					!consultaDocumentosData &&
					verifyUpload()
				) {
					dispatch(
						consultaDocumentosRequest(token, {
							cpf: cadastroRg.form.principal.cpf,
							rg: cadastroRg.form.principal.numeroRg,
						}),
					);
				}
			} else {
				history.push(ROUTE_IIRGD);
			}

			// Primeira via do RG (Novo).
			if (
				cadastroRg.config?.novo &&
				cadastroRg.tipo.primeiraVia &&
				consultaPesquisaCidadao.form
			) {
				const {
					numeroRg,
					digitoRg,
					nome,
					nomePai,
					nomeMae,
					dataNascimento,
					codigoNaturalidade,
					municipioNaturalidade,
					naturalidadeEstrangeira,
					filiacaoTres,
					filiacaoQuatro,
					filiacaoCinco,
					filiacaoSeis,
				} = consultaPesquisaCidadao.form;
				const body: IFormCadastroRg = initialValuesForm;
				// Principal
				if (cadastroRg.config?.acervo) {
					body.numeroRg = `${numeroRg}-${digitoRg}`;
				}
				body.numeroRg = '';
				body.pidt = `${login.user.posto}-${login.user.digito_posto}`;
				body.nome = nome;
				body.nomePai = nomePai;
				body.nomeMae = nomeMae;
				body.dataNascimento = dataNascimento;
				body.codigoNaturalidade = codigoNaturalidade;
				body.municipioNaturalidade = municipioNaturalidade;
				body.multifiliacao =
					verifyLocationIsAllowedMultifiliacao() &&
					(!!filiacaoTres ||
						!!filiacaoQuatro ||
						!!filiacaoCinco ||
						!!filiacaoSeis);
				body.filiacaoTres = filiacaoTres || '';
				body.filiacaoQuatro = filiacaoQuatro || '';
				body.filiacaoCinco = filiacaoCinco || '';
				body.filiacaoSeis = filiacaoSeis || '';
				// Documento apresentado
				body.naturalidadeEstrangeira = naturalidadeEstrangeira;
				body.dni = '10977';
				setFormInitialValues(body);
			}

			// Segunda via do RG (Acervo).
			if (
				cadastroRg.config?.acervo &&
				cadastroRg.tipo.segundaVia &&
				consultaPesquisaCidadao.form
			) {
				const {
					nome,
					nomePai,
					nomeMae,
					dataNascimento,
					codigoNaturalidade,
					municipioNaturalidade,
					naturalidadeEstrangeira,
					numeroRg,
					digitoRg,
					filiacaoTres,
					filiacaoQuatro,
					filiacaoCinco,
					filiacaoSeis,
				} = consultaPesquisaCidadao.form;
				const body: IFormCadastroRg = initialValuesForm;
				// Principal
				body.pidt = `${login.user.posto}-${login.user.digito_posto}`;
				body.nome = nome;
				body.nomePai = nomePai;
				body.nomeMae = nomeMae;
				body.dataNascimento = dataNascimento;
				body.codigoNaturalidade = codigoNaturalidade;
				body.municipioNaturalidade = municipioNaturalidade;
				body.numeroRg = `${numeroRg}-${digitoRg}`;
				body.multifiliacao =
					verifyLocationIsAllowedMultifiliacao() &&
					(!!filiacaoTres ||
						!!filiacaoQuatro ||
						!!filiacaoCinco ||
						!!filiacaoSeis);
				body.filiacaoTres = filiacaoTres || '';
				body.filiacaoQuatro = filiacaoQuatro || '';
				body.filiacaoCinco = filiacaoCinco || '';
				body.filiacaoSeis = filiacaoSeis || '';
				body.dni = '10977';

				// Documento apresentado
				body.naturalidadeEstrangeira = naturalidadeEstrangeira;
				setFormInitialValues(body);

				if (cadastroRg.original === null) {
					const original = {
						...body,
					};
					dispatch(cadastroRgOriginal(original));
				}
			}

			// Primeira via ou Segunda via do RG (Edição).
			if (
				((cadastroRg.config?.edicao && cadastroRg.tipo.primeiraVia) ||
					cadastroRg.tipo.segundaVia) &&
				consultaPesquisaCirg.data &&
				consultaPesquisaCidadao.selecionado
			) {
				const body: IFormCadastroRg = {} as IFormCadastroRg;
				// Principal
				body.numeroRg = consultaPesquisaCirg.data.numeroRg || '';
				body.pidt = `${login.user.posto}-${login.user.digito_posto}`;
				body.nome = consultaPesquisaCirg.data.nome || '';
				body.nomeSocial = consultaPesquisaCirg.data.nomeSocial || '';
				body.nomePai = consultaPesquisaCirg.data.nomePai || '';
				body.nomeMae = consultaPesquisaCirg.data.nomeMae || '';
				body.sexo = consultaPesquisaCirg.data.sexo || '';
				body.genero = consultaPesquisaCirg.data.genero || '';
				body.dataNascimento = consultaPesquisaCirg.data.dataNascimento
					? formatDate(consultaPesquisaCirg.data.dataNascimento)
					: '';
				body.codigoNaturalidade =
					consultaPesquisaCirg.data.codigoNaturalidade || '';
				body.municipioNaturalidade =
					consultaPesquisaCirg.data.municipioNaturalidade || '';
				body.multifiliacao =
					verifyLocationIsAllowedMultifiliacao() &&
					(!!consultaPesquisaCirg.data.filiacaoTres ||
						!!consultaPesquisaCirg.data.filiacaoQuatro ||
						!!consultaPesquisaCirg.data.filiacaoCinco ||
						!!consultaPesquisaCirg.data.filiacaoSeis);
				body.filiacaoTres = consultaPesquisaCirg.data.filiacaoTres || '';
				body.filiacaoQuatro = consultaPesquisaCirg.data.filiacaoQuatro || '';
				body.filiacaoCinco = consultaPesquisaCirg.data.filiacaoCinco || '';
				body.filiacaoSeis = consultaPesquisaCirg.data.filiacaoSeis || '';
				body.cpfResponsavel = consultaPesquisaCirg.data.cpfResponsavel
					? completarCPF(consultaPesquisaCirg.data.cpfResponsavel)
					: '';
				body.tipoVinculo =
					consultaPesquisaCirg.data.tipoVinculo === '0'
						? ''
						: consultaPesquisaCirg.data.tipoVinculo;
				body.dataValidadeCNH = consultaPesquisaCirg.data.dataValidadeCNH
					? formatDate(consultaPesquisaCirg.data.dataValidadeCNH)
					: '';

				// Documento apresentado
				handleClearTypeDocumentNC(body);

				// TRATAMENTO FEITO PARA QUANDO O TIPO DOCUMENTO NÃO ESTIVER NOS ENUMS
				// ELE IRÁ DEIXAR EM BRANCO PARA QUE O OPERADOR SELECIONE OS DADOS CORRETOS
				if (
					!data.tipoDocumento.filter(
						(item: OptionProps) =>
							consultaPesquisaCirg !== null &&
							consultaPesquisaCirg.data &&
							item.value === consultaPesquisaCirg.data.dbas,
					)
				) {
					body.dbas = '';
					body.comarca = '';
					body.cartorio = '';
					body.livro = '';
					body.folha = '';
					body.numero = '';
					body.dataDocumento = '';
					body.motivoFaltaAssinatura = '1';
					body.naturalidadeEstrangeira = false;
					body.pMinLei1 = '';
					body.pMinLei2 = '';
				} else {
					body.dbas = consultaPesquisaCirg.data.dbas || '';
					body.comarca = consultaPesquisaCirg.data.comarca || '';
					body.cartorio = consultaPesquisaCirg.data.cartorio || '';
					body.livro = consultaPesquisaCirg.data.livro || '';
					body.folha = consultaPesquisaCirg.data.folha || '';
					body.numero = consultaPesquisaCirg.data.numero || '';
					body.dataDocumento = consultaPesquisaCirg.data.dataDocumento
						? formatDate(consultaPesquisaCirg.data.dataDocumento)
						: '';
					body.motivoFaltaAssinatura = consultaPesquisaCirg.data
						.motivoFaltaAssinatura
						? consultaPesquisaCirg.data.motivoFaltaAssinatura
						: '1';
					body.naturalidadeEstrangeira = !!(
						consultaPesquisaCirg.data.pMinLei1 ||
						consultaPesquisaCirg.data.pMinLei2
					);
					body.pMinLei1 = consultaPesquisaCirg.data.pMinLei1 || '';
					body.pMinLei2 = consultaPesquisaCirg.data.pMinLei2 || '';
				}

				// Dados adicionais - Cidadão
				body.estadoCivil = consultaPesquisaCirg.data.estadoCivil || '';
				body.cutis = consultaPesquisaCirg.data.cutis || '';
				body.cabelos = consultaPesquisaCirg.data.cabelos || '';
				body.olhos = consultaPesquisaCirg.data.olhos || '';
				body.altura = `${consultaPesquisaCirg.data.alturaM},${consultaPesquisaCirg.data.alturaCm}`;
				body.grauInstrucao = consultaPesquisaCirg.data.grauInstrucao || '';
				body.profissao = consultaPesquisaCirg.data.profissao || '';
				body.cepResidencia = consultaPesquisaCirg.data.cepResidencia || '';
				body.enderecoResidencia =
					consultaPesquisaCirg.data.enderecoResidencia || '';
				body.numeroResidencia =
					consultaPesquisaCirg.data.numeroResidencia || '';
				body.complementoResidencia =
					consultaPesquisaCirg.data.complementoResidencia || '';
				body.bairroResidencia =
					consultaPesquisaCirg.data.bairroResidencia || '';
				body.codigoMunicipioResidencia =
					consultaPesquisaCirg.data.codigoMunicipioResidencia || '';
				body.descMunicipioResidencia =
					consultaPesquisaCirg.data.descMunicipioResidencia || '';
				body.ufResidencia = consultaPesquisaCirg.data.ufResidencia || '';

				// Dados adicionais - Trabalho
				body.cepTrabalho = consultaPesquisaCirg.data.cepTrabalho || '';
				body.enderecoTrabalho =
					consultaPesquisaCirg.data.enderecoTrabalho || '';
				body.numeroTrabalho = consultaPesquisaCirg.data.numeroTrabalho || '';
				body.complementoTrabalho =
					consultaPesquisaCirg.data.complementoTrabalho || '';
				body.bairroTrabalho = consultaPesquisaCirg.data.bairroTrabalho || '';
				body.codigoMunicipioTrabalho =
					consultaPesquisaCirg.data.codigoMunicipioTrabalho || '';
				body.descMunicipioTrabalho =
					consultaPesquisaCirg.data.descMunicipioTrabalho || '';

				// Dados adicionais - Contato
				body.solicitacao = '1';
				body.foneResidencia = consultaPesquisaCirg.data.foneResidencia || '';
				body.foneComercial = consultaPesquisaCirg.data.foneComercial || '';
				body.celular = consultaPesquisaCirg.data.celular || '';
				body.operadora = consultaPesquisaCirg.data.operadora || '';
				body.email = consultaPesquisaCirg.data.email || '';

				// Informações adicionais
				body.identificadoAssina =
					consultaPesquisaCirg.data.identificadoAssina === 'S';
				body.carimboMaior65 = consultaPesquisaCirg.data.carimboMaior65 === '2';
				body.tipoSanguineo = consultaPesquisaCirg.data.tipoSanguineo || '';
				body.cid1 = consultaPesquisaCirg.data.cid1 || '';
				body.cid2 = consultaPesquisaCirg.data.cid2 || '';
				body.cid3 = consultaPesquisaCirg.data.cid3 || '';
				body.cid4 = consultaPesquisaCirg.data.cid4 || '';

				// Dados adicionais - RG
				body.cpf = consultaPesquisaCirg.data.cpf || '';
				body.naoPossuiCpf = false;
				body.pis = consultaPesquisaCirg.data.pis || '';
				body.pasep = consultaPesquisaCirg.data.pasep || '';
				body.dni = '10977';
				body.tituloEleitor = consultaPesquisaCirg.data.tituloEleitor || '';
				body.ctpsNum = consultaPesquisaCirg.data.ctpsNum || '';
				body.ctpsSerie = consultaPesquisaCirg.data.ctpsSerie || '';
				body.ctpsSerieUf = consultaPesquisaCirg.data.ctpsSerieUf || '';
				body.certidaoMilitar =
					consultaPesquisaCirg.data.certidaoMilitar?.substring(0, 12) || '';
				body.cnh = consultaPesquisaCirg.data.cnh || '';
				body.categoriaCnh = consultaPesquisaCirg.data.categoriaCnh || '';
				body.doador =
					calcularIdade(formatDate(consultaPesquisaCirg.data.dataNascimento)) <
					18
						? false
						: consultaPesquisaCirg.data.doador || false;
				body.nascSaude = consultaPesquisaCirg.data.nascSaude || '';
				body.identProf1 = consultaPesquisaCirg.data.identProf1 || '';
				body.orgaoEmissor1 = consultaPesquisaCirg.data.orgaoEmissor1 || '';
				body.identProf2 = consultaPesquisaCirg.data.identProf2 || '';
				body.orgaoEmissor2 = consultaPesquisaCirg.data.orgaoEmissor2 || '';
				body.identProf3 = consultaPesquisaCirg.data.identProf3 || '';
				body.orgaoEmissor3 = consultaPesquisaCirg.data.orgaoEmissor3 || '';

				setFormInitialValues(body);

				if (cadastroRg.original === null) {
					const original = {
						...body,
					};
					dispatch(cadastroRgOriginal(original));
				}
			}

			// Quando já existe um formulário em andamento.
			if (cadastroRg.form.principal) {
				const formData = cadastroRg.form.principal;

				const body: IFormCadastroRg = {} as IFormCadastroRg;

				// Principal
				body.numeroRg = formData.numeroRg;
				body.pidt = formData.pidt;
				body.nome = formData.nome;
				body.nomeSocial = formData.nomeSocial;
				body.nomePai = formData.nomePai;
				body.nomeMae = formData.nomeMae;
				body.sexo = formData.sexo;
				body.genero = formData.genero || '';
				body.dataNascimento = formData.dataNascimento;
				body.codigoNaturalidade = formData.codigoNaturalidade;
				body.municipioNaturalidade = formData.municipioNaturalidade;
				body.multifiliacao =
					verifyLocationIsAllowedMultifiliacao() && formData.multifiliacao;
				body.filiacaoTres = formData.filiacaoTres;
				body.filiacaoQuatro = formData.filiacaoQuatro;
				body.filiacaoCinco = formData.filiacaoCinco;
				body.filiacaoSeis = formData.filiacaoSeis;
				body.cpfResponsavel = formData.cpfResponsavel;
				body.tipoVinculo =
					formData.tipoVinculo === '0' ? '' : formData.tipoVinculo;
				body.dataValidadeCNH = formData.dataValidadeCNH;

				// Documento apresentado
				handleClearTypeDocumentNC(body);

				body.dbas = formData.dbas;
				body.comarca = formData.comarca;
				body.cartorio = formData.cartorio;
				body.livro = formData.livro;
				body.folha = formData.folha;
				body.numero = formData.numero;
				body.dataDocumento = formData.dataDocumento;
				body.naturalidadeEstrangeira = formData.naturalidadeEstrangeira;
				body.pMinLei1 = formData.pMinLei1;
				body.pMinLei2 = formData.pMinLei2;

				// Dados adicionais - Cidadão
				body.estadoCivil = formData.estadoCivil;
				body.cutis = formData.cutis;
				body.cabelos = formData.cabelos;
				body.olhos = formData.olhos;
				body.altura = formData.altura;
				body.grauInstrucao = formData.grauInstrucao;
				body.profissao = formData.profissao;
				body.cepResidencia = formData.cepResidencia;
				body.enderecoResidencia = formData.enderecoResidencia;
				body.numeroResidencia = formData.numeroResidencia;
				body.complementoResidencia = formData.complementoResidencia;
				body.bairroResidencia = formData.bairroResidencia;
				body.codigoMunicipioResidencia = formData.codigoMunicipioResidencia;
				body.descMunicipioResidencia = formData.descMunicipioResidencia;
				body.ufResidencia = formData.ufResidencia;

				// Dados adicionais - Trabalho
				body.cepTrabalho = formData.cepTrabalho;
				body.enderecoTrabalho = formData.enderecoTrabalho;
				body.numeroTrabalho = formData.numeroTrabalho;
				body.complementoTrabalho = formData.complementoTrabalho;
				body.bairroTrabalho = formData.bairroTrabalho;
				body.codigoMunicipioTrabalho = formData.codigoMunicipioTrabalho;
				body.descMunicipioTrabalho = formData.descMunicipioTrabalho;

				// Dados adicionais - Contato
				body.solicitacao = formData.solicitacao;
				body.foneResidencia = formData.foneResidencia;
				body.foneComercial = formData.foneComercial;
				body.celular = formData.celular;
				body.operadora = formData.operadora;
				body.email = formData.email;

				// Informações adicionais
				body.identificadoAssina = formData.identificadoAssina;
				body.carimboMaior65 = formData.carimboMaior65;
				body.tipoSanguineo = formData.tipoSanguineo;
				body.cid1 = formData.cid1;
				body.cid2 = formData.cid2;
				body.cid3 = formData.cid3;
				body.cid4 = formData.cid4;
				body.motivoFaltaAssinatura = formData?.motivoFaltaAssinatura
					? formData?.motivoFaltaAssinatura
					: '1';

				// Dados adicionais - RG
				body.inscricaoCpf = formData.inscricaoCpf;
				body.cpf = formData.cpf;
				body.naoPossuiCpf = false;
				body.pis = formData.pis;
				body.pasep = formData.pasep;
				body.dni = '10977';
				body.tituloEleitor = formData.tituloEleitor;
				body.ctpsNum = formData.ctpsNum;
				body.ctpsSerie = formData.ctpsSerie;
				body.ctpsSerieUf = formData.ctpsSerieUf;
				body.certidaoMilitar = formData.certidaoMilitar;
				body.cnh = formData.cnh;
				body.categoriaCnh = formData.categoriaCnh;
				body.doador = formData.doador;
				body.nascSaude = formData.nascSaude;
				body.identProf1 = formData.identProf1;
				body.orgaoEmissor1 = formData.orgaoEmissor1;
				body.identProf2 = formData.identProf2;
				body.orgaoEmissor2 = formData.orgaoEmissor2;
				body.identProf3 = formData.identProf3;
				body.orgaoEmissor3 = formData.orgaoEmissor3;

				// Entrega RG
				body.entrega =
					typeof formData.entrega === 'number' ? 'KC' : formData.entrega;
				body.qtdKitFamilia =
					typeof formData.entrega === 'number' ? formData.entrega : '';
				body.data = formData.data;
				body.hora = formData.hora;
				setFormInitialValues(body);
			}

			setHasLoaded(true);
		}
	}, [
		verifyLocationIsAllowedMultifiliacao,
		hasLoaded,
		dispatch,
		history,
		login,
		consultaPesquisaCirg,
		consultaPesquisaCidadao,
		cadastroRg.config,
		cadastroRg.tipo,
		cadastroRg.original,
		cadastroRg.form.principal,
		setHasLoaded,
		handleClearTypeDocumentNC,
		consultaDocumentosData,
		token,
		verifyUpload,
	]);

	useEffect(() => {
		if (cadastroRg.config?.edicao && consultaDocumentosData?.urlArquivo) {
			const existingUrl = consultaDocumentosData.urlArquivo;
			const existingFileName =
				existingUrl.substring(existingUrl.lastIndexOf('/') + 1) ||
				'Documento Carregado';

			setUploadedFileUrlForDivergence(existingUrl);
			setUploadedNameDivergence(existingFileName);
			setDivergenceAntdFileList([
				{
					uid: '-1',
					name: existingFileName,
					status: 'done',
					url: existingUrl,
					thumbUrl: existingUrl,
				},
			]);
		}
	}, [cadastroRg.config, consultaDocumentosData]);

	const handleValidate = useCallback(
		values => {
			const hasFormErrors =
				notifications.errors.length > 0 &&
				notifications.notificationOrigin === 'FORM_VALIDATE';

			if (notifications.notificationOrigin !== 'SERVICE_SGU') {
				return getFormValidationsErrors(
					values,
					schema,
					undefined,
					hasFormErrors,
				);
			}
		},
		[notifications.errors.length, notifications.notificationOrigin],
	);

	const validaCin = useCallback(
		(values: IFormCadastroRg) => {
			if (values.dni === '10977' && values.naoPossuiCpf) {
				const payload: IncluirRequest = {
					descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
					tipoDocumento: 'CIN',
					numeroDocumento: formValues?.numeroRg ?? '',
					codigoLocalidade: Number(login.user.posto),
					idOrgao: login.user.idOrgao,
					cpf: login.user.cpf,
					descricaoServico: 'ATENDIMENTO_CIN',
					flagConfronto: 'N',
					idMotivo: 16,
					numeroProcesso: atendimento.salvarAtendimento.data?.idAtendimento,
					observacao: `Cidadão informou não possui CPF`,
				};
				dispatch(estatisticaIncluirRequest(token, payload));
				addNotifications({
					errors: [
						'Para a solicitação de emissão da CIN é necessário informar o CPF do cidadão. Caso não informe o CPF somente será possível a emissão de um RE Estadual (RGE).',
					],
					notificationOrigin: 'SERVICE_SGU',
				});
			} else if (values.dni === '10977' && (!values.cpf || values.cpf === '')) {
				const payload: IncluirRequest = {
					descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
					tipoDocumento: 'CIN',
					numeroDocumento: formValues?.numeroRg ?? '',
					codigoLocalidade: Number(login.user.posto),
					idOrgao: login.user.idOrgao,
					cpf: login.user.cpf,
					descricaoServico: 'ATENDIMENTO_CIN',
					flagConfronto: 'N',
					idMotivo: 16,
					numeroProcesso: atendimento.salvarAtendimento.data?.idAtendimento,
					observacao: `Cidadão não informou o CPF para emitir CIN`,
				};
				dispatch(estatisticaIncluirRequest(token, payload));
				addNotifications({
					errors: ['O campo CPF é obrigatório para a CIN.'],
					notificationOrigin: 'SERVICE_SGU',
				});
			} else if (values.dni === '10977') {
				const payload: IncluirRequest = {
					descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
					tipoDocumento: 'CIN',
					numeroDocumento: values.cpf || values.numeroRg,
					codigoLocalidade: Number(login.user.posto),
					idOrgao: login.user.idOrgao,
					cpf: login.user.cpf,
					descricaoServico: 'ATENDIMENTO_CIN',
					flagConfronto: 'N',
					idMotivo: 16,
					numeroProcesso: atendimento.salvarAtendimento.data?.idAtendimento,
					observacao: `CIN com CPF informado: ${values.cpf}`,
				};
				dispatch(estatisticaIncluirRequest(token, payload));

				dispatch(consultarProcessoClear());

				dispatch(
					consultarCpfCinRequest(
						token,
						values.cpf.replace('-', '').replaceAll('.', ''),
						undefined,
						'cadastro-rg',
					),
				);
			}
		},
		[
			atendimento.salvarAtendimento.data,
			dispatch,
			formValues,
			login.user,
			token,
		],
	);

	const gerarMensagemValidacao = (
		nameValidation: boolean,
		motherNameValidation: boolean,
		birthDayValidation: boolean,
		uploadRenderJSX: JSX.Element | string,
		hasCPFDivergence?: boolean,
	) => {
		if (consultarCin.data) {
			const hasDataRFBDivergences =
				!nameValidation || !motherNameValidation || !birthDayValidation;

			const nomeMsg = nameValidation ? (
				<>
					<strong>Nome cidadão:</strong> OK
				</>
			) : (
				<>
					<strong>Nome cidadão:</strong> NOK <br /> <strong>RFB:</strong>{' '}
					{letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
						consultarCin.data.nomeContribuinte,
					)
						.toUpperCase()
						.trim()}{' '}
					<br /> <strong>BU:</strong>{' '}
					{letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
						formValues?.nome || '',
					)
						.toUpperCase()
						.trim()}
				</>
			);

			const maeMsg = motherNameValidation ? (
				<>
					<strong>Filiação 2:</strong> OK
				</>
			) : (
				<>
					<strong>Filiação 2:</strong> NOK <br /> <strong>RFB:</strong>{' '}
					{letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
						consultarCin.data.nomeMae,
					)
						.toUpperCase()
						.trim()}
					<br /> <strong>BU:</strong>{' '}
					{letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
						formValues?.nomeMae || '',
					)
						.toUpperCase()
						.trim()}
				</>
			);

			const nascimentoMsg = birthDayValidation ? (
				<>
					<strong>Data nascimento:</strong> OK
				</>
			) : (
				<>
					<strong>Data nascimento:</strong> NOK <br /> <strong>RFB:</strong>{' '}
					{consultarCin.data.dtNasc.substring(6, 8)}/
					{consultarCin.data.dtNasc.substring(4, 6)}/
					{consultarCin.data.dtNasc.substring(0, 4)} <br />
					<strong>BU:</strong> {formValues?.dataNascimento.trim()}
				</>
			);

			return (
				<div>
					<p>
						<strong>
							Constatamos Divergências com a base da Receita Federal:
						</strong>
					</p>

					{hasCPFDivergence && hasDataRFBDivergences && (
						<p>
							<strong>Situação do CPF:</strong> Diverge de regular e pendente de
							regularização, será analisada pela Receita Federal do Brasil.
						</p>
					)}
					{hasCPFDivergence && !hasDataRFBDivergences && (
						<>
							<p>
								<strong>Situação do CPF:</strong> Diverge de regular e pendente
								de regularização.
							</p>
							<p style={{ marginTop: '10px' }}>
								Inclua a Certidão para que a situação do CPF seja analisada pela
								Receita Federal.
							</p>
						</>
					)}

					{hasDataRFBDivergences && (
						<>
							<p style={{ marginTop: '5px' }}>{nomeMsg}</p>
							<p style={{ marginTop: '5px' }}>{maeMsg}</p>
							<p style={{ marginTop: '5px' }}>{nascimentoMsg}</p>
							<p style={{ marginTop: '10px' }}>
								<u>
									Verifique se há erro de digitação para a divergência acima ou
									se está na RFB.
								</u>
							</p>
							<p style={{ marginTop: '5px' }}>
								Cadastro do BU correto, inclua a Certidão. As informações
								inseridas neste atendimento serão atualizadas na Receita
								Federal.
							</p>
						</>
					)}
					{((hasCPFDivergence && hasDataRFBDivergences) ||
						hasCPFDivergence) && (
						<>
							<p style={{ marginTop: '5px' }}>
								Em casos dos documentos com informações no verso, solicitamos
								que sejam escaneados frente e verso, no mesmo arquivo.
							</p>
							<p style={{ marginTop: '5px', marginBottom: '15px' }}>
								Por favor inserir documento Certidão.
							</p>
						</>
					)}
					{uploadRenderJSX}
				</div>
			);
		}
		return '';
	};

	const submitForm = useCallback(
		(values: IFormCadastroRg) => {
			if (cadastroRg.status !== 100) {
				if (rfbDivergenceData) {
					values.dadosRfb = rfbDivergenceData;
					values.divergenciaRfb = true;
				}

				values.multifiliacao =
					verifyLocationIsAllowedMultifiliacao() && values.multifiliacao;
				values.cnh = completaZeroEsquerda(values.cnh, 11);
				values.tituloEleitor = completaZeroEsquerda(values.tituloEleitor, 12);
				values.filiacaoTres =
					verifyLocationIsAllowedMultifiliacao() && values.multifiliacao
						? values.filiacaoTres.toUpperCase()
						: '';
				values.filiacaoQuatro =
					verifyLocationIsAllowedMultifiliacao() && values.multifiliacao
						? values.filiacaoQuatro.toUpperCase()
						: '';
				values.filiacaoCinco =
					verifyLocationIsAllowedMultifiliacao() && values.multifiliacao
						? values.filiacaoCinco.toUpperCase()
						: '';
				values.filiacaoSeis =
					verifyLocationIsAllowedMultifiliacao() && values.multifiliacao
						? values.filiacaoSeis.toUpperCase()
						: '';
				values.doador = values.doador === true;

				if (
					values.cpfResponsavel &&
					values.cpfResponsavel !== '' &&
					!checkResponsavel
				) {
					const cpfResponsavel = limparMascara(values.cpfResponsavel);
					dispatch(
						consultarCpfCinResponsavelRequest(
							token,
							cpfResponsavel,
							'cadastro-rg',
						),
					);
					setCheckResponsavel(true);
					return;
				}

				if (
					(cadastroRg.config?.edicao &&
						cadastroRg.original &&
						!cadastroRg.config?.acervo) ||
					(values.numeroRg.length > 1 && !cadastroRg.config?.acervo)
				) {
					if (values.entrega === 'KC') {
						dispatch(
							atualizarRgRequest(
								token,
								cadastroRg.original,
								{ ...values, entrega: Number(values.qtdKitFamilia) },
								login,
								cadastroRg.tipo.primeiraVia,
								consultaPesquisaCidadao.selecionado,
							),
						);
						setHasSubmit(true);
						return;
					}
					dispatch(
						atualizarRgRequest(
							token,
							cadastroRg.original,
							values,
							login,
							cadastroRg.tipo.primeiraVia,
							consultaPesquisaCidadao.selecionado,
						),
					);
					setHasSubmit(true);
					return;
				}

				values.cpf = limparMascara(values.cpf);
				values.tituloEleitor = completaZeroEsquerda(values.tituloEleitor, 12);

				// Montar lógica para sinalizar quando o RG for Acervo.
				if (cadastroRg.config?.acervo) {
					values.argumento = 'acervo';
				}
				if (values.entrega === 'KC') {
					if (
						cadastroRg.cadastrarRgFailure &&
						cadastroRg.config?.acervo &&
						cadastroRg.numeroRg
					) {
						dispatch(
							atualizarRgRequest(
								token,
								cadastroRg.original,
								values,
								login,
								cadastroRg.tipo.primeiraVia,
								consultaPesquisaCidadao.selecionado,
							),
						);
						setHasSubmit(true);
						return;
					}
					dispatch(
						cadastrarRgRequest(
							token,
							{ ...values, entrega: Number(values.qtdKitFamilia) },
							login,
						),
					);
					setHasSubmit(true);
					return;
				}
				if (
					cadastroRg.cadastrarRgFailure &&
					cadastroRg.config?.acervo &&
					cadastroRg.numeroRg
				) {
					dispatch(
						atualizarRgRequest(
							token,
							cadastroRg.original,
							values,
							login,
							cadastroRg.tipo.primeiraVia,
							consultaPesquisaCidadao.selecionado,
						),
					);
					setHasSubmit(true);
					return;
				}
				setCadastraRg(true);
				dispatch(cadastrarRgRequest(token, values, login));
				setHasSubmit(true);
			}
		},
		[
			verifyLocationIsAllowedMultifiliacao,
			cadastroRg.config,
			cadastroRg.original,
			cadastroRg.cadastrarRgFailure,
			cadastroRg.numeroRg,
			cadastroRg.tipo.primeiraVia,
			cadastroRg.status,
			dispatch,
			login,
			consultaPesquisaCidadao.selecionado,
			token,
			checkResponsavel,
			rfbDivergenceData,
		],
	);

	useEffect(() => {
		if (
			checkResponsavel &&
			consultarCpfCinResponsavel.data?.codSitCad &&
			consultarCpfCinResponsavel.instanceRequest === 'cadastro-rg'
		) {
			const codSitCad = consultarCpfCinResponsavel.data?.codSitCad || '';

			if (codSitCad !== '0' && codSitCad !== '4') {
				const descricaoSituacao = getDescricaoSituationCin(codSitCad);

				addNotifications({
					errors: [
						`A inclusão do CPF do Responsável e vínculo do responsável somente será permitida se a situação do CPF do responsável na RFB for igual a “0-REGULAR” e “4-PENDENTE DE REGULARIZAÇÃO”. A situação do CPF informado é: ${codSitCad} - ${descricaoSituacao}`,
					],
				});
				setCheckResponsavel(false);
			} else if (!cadastraRG) {
				formValues && submitForm(formValues);
				setCheckResponsavel(false);
			}
		}
	}, [
		checkResponsavel,
		consultarCpfCinResponsavel,
		formValues,
		submitForm,
		cadastraRG,
	]);

	useEffect(() => {
		if (
			consultarProcesso.status === 200 &&
			consultarProcesso.data &&
			formValues
		) {
			const proccess = verifyCinProccesses(consultarProcesso.data);

			if (proccess.isAllowed) {
				submitForm(formValues);
			}

			if (!proccess.isAllowed && proccess.message) {
				addNotifications({
					errors: [proccess.message],
					notificationOrigin: 'SERVICE_SGU',
				});
				setErroCIN(true);
			}
		} else if (
			consultarProcesso.status !== 0 &&
			consultarProcesso.status !== 200
		) {
			if (caller1 > 3) {
				addNotifications({
					errors: [
						'Problemas na conexão com Receita Federal. Tente Novamente.',
					],
					notificationOrigin: 'SERVICE_SGU',
				});
			} else if (formValues?.cpf) {
				setCaller1(caller1 + 1);
				dispatch(
					consultarProcessoRequest(token, {
						cpfCidadao:
							formValues.cpf.replace('-', '').replaceAll('.', '') || '',
					}),
				);
			}
		} else if (
			consultarProcesso.status !== 0 &&
			cpfStatus.data &&
			cpfStatus.instanceRequest === 'cadastro-rg' &&
			cpfStatus.data.cpfId === limparMascara(formValues?.cpf)
		) {
			setErroCIN(true);
			addNotifications({
				errors: [
					'Emissão da CIN não poderá ser realizada neste momento no estado de São Paulo. Dados informados divergem dos dados cadastrados na Receita Federal.',
				],
				notificationOrigin: 'SERVICE_SGU',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [consultarProcesso.data, consultarProcesso.status]);

	const uploadRenderContent = verifyUpload() ? (
		<Formik
			initialValues={{
				certidaoUrlAnexada: uploadedFileUrlForDivergence,
				certidaoNomeAnexada: uploadedNameDivergence,
			}}
			enableReinitialize
			onSubmit={(values, { setSubmitting, resetForm }) => {
				if (!uploadedFileUrlForDivergence) {
					AntMessage.error(
						'Por favor, anexe o documento de certidão antes de registrar.',
					);
					setSubmitting(false);
					return;
				}
				const payload = {
					cpf: formValues?.cpf || '',
					rg: formValues?.numeroRg || '',
					urlArquivo: uploadedFileUrlForDivergence,
				};
				dispatch(cadastraDocumentosRequest(token, payload));

				AntMessage.info('Enviando registro do documento...');
				setTimeout(() => {
					AntMessage.success('Registro de documento enviado (Simulado).');
					setUploadedFileUrlForDivergence('');
					setDivergenceAntdFileList([]);
					resetForm();
					setSubmitting(false);
				}, 1500);
			}}
		>
			{({ setFieldValue, isSubmitting, values }) => {
				const antDUploadProps = {
					name: 'file',
					multiple: false,
					accept: '.pdf,.png,.jpg,.jpeg',
					fileList: divergenceAntdFileList,
					itemRender: () => null,
					customRequest: async ({
						file,
						onSuccess,
						onError,
						onProgress,
					}: any) => {
						const rcFile = file as File & { uid: string; originFileObj?: File };
						const currentFileUid = rcFile.uid;
						const currentFileName = rcFile.name;
						const actualFileToUpload = rcFile.originFileObj || rcFile;

						setIsUploadingDivergenceFile(true);
						setUploadDivergenceError(null);

						setDivergenceAntdFileList([
							{
								uid: currentFileUid,
								name: currentFileName,
								status: 'uploading',
								percent: 0,
							},
						]);
						const tamanhoMaximoBytes = 1500000; // 1.5MB
						const tiposPermitidosMIME = [
							'application/pdf',
							'image/jpeg',
							'image/png',
						];
						const extensoesPermitidas = ['.pdf', '.jpg', '.jpeg', '.png'];
						const nomeArquivoOriginal = currentFileName.toLowerCase();
						const extensaoArquivoOriginal = nomeArquivoOriginal.substring(
							nomeArquivoOriginal.lastIndexOf('.'),
						);

						let isValidType = tiposPermitidosMIME.includes(rcFile.type);
						if (
							!isValidType &&
							extensoesPermitidas.includes(extensaoArquivoOriginal)
						) {
							if (
								rcFile.type === 'application/octet-stream' ||
								!rcFile.type ||
								rcFile.type === ''
							) {
								isValidType = true;
							}
						}

						if (!isValidType) {
							const errorMsg =
								'Tipo de arquivo inválido. Apenas PDF, PNG, JPG, JPEG são aceitos.';
							setUploadDivergenceError(errorMsg);
							AntMessage.error(errorMsg);
							setUploadedFileUrlForDivergence('');
							setFieldValue('certidaoUrlAnexada', '');
							setIsUploadingDivergenceFile(false);
							setDivergenceAntdFileList([
								{
									uid: currentFileUid,
									name: currentFileName,
									status: 'error',
									response: errorMsg,
								},
							]);
							if (onError) onError(new Error(errorMsg));
							return;
						}

						if (rcFile.size > tamanhoMaximoBytes) {
							const errorMsg = 'Tamanho máximo permitido é de 1.5MB.';
							setUploadDivergenceError(errorMsg);
							AntMessage.error(errorMsg);
							setUploadedFileUrlForDivergence('');
							setFieldValue('certidaoUrlAnexada', '');
							setIsUploadingDivergenceFile(false);
							setDivergenceAntdFileList([
								{
									uid: currentFileUid,
									name: currentFileName,
									status: 'error',
									response: errorMsg,
								},
							]);
							if (onError) onError(new Error(errorMsg));
							return;
						}

						const formData = new FormData();
						formData.append('file', actualFileToUpload as Blob);
						const uploadUrlTarget = `${treatPathBaseIntegradorUrl(
							PATH_ARQUIVOS_API,
						)}/ds/${uuidv4()}`;

						try {
							const response = await axios.post(
								uploadUrlTarget,
								actualFileToUpload,
								{
									headers: {
										'Content-Type': 'application/octet-stream',
										Authorization: `Bearer ${token}`,
									},
									onUploadProgress: (event: any) => {
										if (event.total && onProgress) {
											const percent = Math.round(
												(event.loaded / event.total) * 100,
											);
											onProgress({ percent });
											setDivergenceAntdFileList([
												{
													uid: currentFileUid,
													name: currentFileName,
													status: 'uploading',
													percent,
												},
											]);
										}
									},
								},
							);
							const responseData = response.data;
							if (responseData && responseData.url) {
								setUploadedFileUrlForDivergence(responseData.url);
								setFieldValue('certidaoUrlAnexada', responseData.url);
								setUploadedNameDivergence(currentFileName);
								setFieldValue('certidaoNomeAnexada', currentFileName);
								AntMessage.success(`${currentFileName} enviado com sucesso.`);

								setTimeout(() => {
									const payload = {
										cpf: formValues?.cpf || '',
										rg: formValues?.numeroRg || '',
										urlArquivo: responseData.url,
									};

									dispatch(cadastraDocumentosRequest(token, payload));
								}, 3000);

								setDivergenceAntdFileList([
									{
										uid: currentFileUid,
										name: currentFileName,
										status: 'done',
										url: responseData.url,
										thumbUrl: responseData.url,
									},
								]);
								if (onSuccess) onSuccess(responseData, file);
							} else {
								throw new Error('URL não retornada pelo servidor após upload.');
							}
						} catch (err) {
							console.error('Erro no upload do arquivo:', err);
							const errorMsg = 'Erro ao fazer upload do arquivo.';
							setUploadDivergenceError(errorMsg);
							AntMessage.error(errorMsg);
							setUploadedFileUrlForDivergence('');
							setUploadedNameDivergence('');
							setFieldValue('certidaoUrlAnexada', '');
							setDivergenceAntdFileList([
								{
									uid: currentFileUid,
									name: currentFileName,
									status: 'error',
									response: errorMsg,
								},
							]);
							if (onError) onError(err);
						} finally {
							setIsUploadingDivergenceFile(false);
						}
					},
					onRemove: (fileToRemove: any) => {
						setUploadedFileUrlForDivergence('');
						setUploadedNameDivergence('');
						setFieldValue('certidaoUrlAnexada', '');
						setUploadDivergenceError(null);
						setDivergenceAntdFileList([]);
						AntMessage.info(`Arquivo ${fileToRemove.name} removido.`);
						return true;
					},
				};

				return (
					<Form>
						<Row>
							<Col span={6}>
								<strong>Arquivo selecionado:</strong>
							</Col>
							<Col span={12}>{values.certidaoUrlAnexada || 'Nenhum'}</Col>
							<Col span={6}>
								<Row>
									<AntButton
										type="primary"
										disabled={values.certidaoUrlAnexada === ''}
										style={{ width: '100%', padding: '4px' }}
										onClick={() => {
											dispatch(
												baixarArquivosRequest(token, {
													url: values.certidaoUrlAnexada,
													instanceRequest: 'arquivoIirgd',
												}),
											);
										}}
									>
										Visualizar Arquivo
									</AntButton>
								</Row>
								<Row>(Apenas PDF)</Row>
							</Col>
						</Row>
						<div
							style={{
								border: '1px dashed #d9d9d9',
								padding: '15px',
								borderRadius: '4px',
								textAlign: 'center',
							}}
						>
							<p>
								<strong>Anexar Documento de Divergência (Certidão)</strong>
							</p>
							<AntUpload {...antDUploadProps}>
								<AntButton
									icon={<UploadOutlined />}
									loading={isUploadingDivergenceFile}
									disabled={isUploadingDivergenceFile}
								>
									{isUploadingDivergenceFile
										? 'Enviando...'
										: 'Selecionar Arquivo'}
								</AntButton>
							</AntUpload>
							<small style={{ display: 'block', marginTop: '8px' }}>
								(Formatos: PDF, PNG, JPG, JPEG - Tamanho Máx: 1.5MB)
							</small>
							{uploadDivergenceError && (
								<div
									style={{
										color: 'red',
										marginTop: '5px',
										fontSize: '0.9em',
									}}
								>
									{uploadDivergenceError}
								</div>
							)}
						</div>
						<Row>
							<Col span={24}>
								<strong>Aviso!</strong>
							</Col>
						</Row>
						<Row>
							<Col span={24}>
								<strong>
									Caso já tenha enviado uma certidão, ao realizar um novo envio,
									a certidão anterior será substituida pelo novo arquivo!
								</strong>
							</Col>
						</Row>
					</Form>
				);
			}}
		</Formik>
	) : (
		''
	);

	useEffect(() => {
		if (
			modalInstanceRef.current &&
			modalCreationArgsRef.current &&
			typeof modalInstanceRef.current.update === 'function'
		) {
			const currentArgs = modalCreationArgsRef.current;

			const newDisabledState =
				verifyUpload() &&
				(uploadedFileUrlForDivergence === '' ||
					(statusDocumentos !== 201 && !consultaDocumentosData));
			const newOkText = verifyUpload()
				? 'Seguir Processo com Envio da Certidão'
				: 'Avançar';

			const currentOkButtonProps = currentArgs.okButtonProps || {};
			if (
				currentOkButtonProps.disabled !== newDisabledState ||
				currentArgs.okText !== newOkText
			) {
				const newModalProps: any = {
					...currentArgs,
					okButtonProps: {
						...currentOkButtonProps,
						disabled: newDisabledState,
					},
					okText: newOkText,
				};

				modalInstanceRef.current.update(newModalProps);
				modalCreationArgsRef.current = newModalProps;
			}
		}
	}, [
		consultaDocumentosData,
		statusDocumentos,
		uploadedFileUrlForDivergence,
		verifyUpload,
	]);

	const displayConfirmModal = (content: React.ReactNode, dadosRfb: any) => {
		if (modalInstanceRef.current) {
			(modalInstanceRef.current as any).destroy();
		}

		if (formValues) {
			const modalProps: any = {
				title: 'Atenção',
				content,
				cancelText: 'Fechar',
				okButtonProps: {
					disabled:
						verifyUpload() &&
						(uploadedFileUrlForDivergence === '' ||
							(statusDocumentos !== 201 && !consultaDocumentosData)),
				},
				okText: verifyUpload()
					? 'Seguir Processo com Envio da Certidão'
					: 'Avançar',
				width: 600,
				onOk() {
					const currentFormValues = formValues;
					if (currentFormValues) {
						currentFormValues.dadosRfb = dadosRfb;
						currentFormValues.divergenciaRfb = true;
						dispatch(
							consultarProcessoRequest(token, {
								cpfCidadao:
									formValues?.cpf.replace('-', '').replaceAll('.', '') || '',
							}),
						);
					}
					modalInstanceRef.current = null;
					modalCreationArgsRef.current = null;
				},
				onCancel() {
					modalInstanceRef.current = null;
					modalCreationArgsRef.current = null;
				},
			};

			modalCreationArgsRef.current = modalProps;
			modalInstanceRef.current = Modal.confirm(modalProps);
		}
	};

	useEffect(() => {
		if (
			consultarProcesso.status !== 200 &&
			consultarCin.status === 200 &&
			consultarCin.instanceRequest === 'cadastro-rg' &&
			consultarCin.data &&
			formValues &&
			formValues.dni === '10977' &&
			consultarCin.data.cpfId === limparMascara(formValues.cpf) &&
			!consultarCin.cpfResponsavel
		) {
			const nameValidation =
				letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
					consultarCin.data.nomeContribuinte,
				)
					.toUpperCase()
					.trim() ===
				letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
					formValues?.nome || '',
				)
					.toUpperCase()
					.trim();

			let maeCIN =
				letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
					consultarCin.data.nomeMae,
				)
					.toUpperCase()
					.trim();

			if (maeCIN === 'MAE DESCONHECIDA' || maeCIN === 'NC' || maeCIN === '') {
				maeCIN = 'NC';
			}

			const motherNameValidation =
				maeCIN ===
				letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
					formValues?.nomeMae || '',
				)
					.toUpperCase()
					.trim();

			const birthDayValidation =
				`${consultarCin.data.dtNasc.substring(
					0,
					4,
				)}-${consultarCin.data.dtNasc.substring(
					4,
					6,
				)}-${consultarCin.data.dtNasc.substring(6, 8)}`.replaceAll(
					/\s\s+/g,
					' ',
				) === unformatDate(formValues?.dataNascimento).trim();

			const hasCPFDivergences =
				consultarCin.data.codSitCad !== '0' &&
				consultarCin.data.codSitCad !== '4';
			const hasDataRFBDivergences =
				!nameValidation || !motherNameValidation || !birthDayValidation;

			if (!hasDataRFBDivergences && !hasCPFDivergences && formValues?.cpf) {
				setRfbDivergenceData(null);
				dispatch(
					consultarProcessoRequest(token, {
						cpfCidadao:
							formValues.cpf.replace('-', '').replaceAll('.', '') || '',
					}),
				);
			} else {
				const isPrimeiraViaFlow = primeiraVia;
				const isUploadFlow = verifyUpload();

				let editedRfbData = '';
				const dadosRfb = `Nome: ${letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
					consultarCin.data.nomeContribuinte,
				)
					.toUpperCase()
					.trim()} - Data nascimento: ${consultarCin.data.dtNasc.substring(
					6,
					8,
				)}/${consultarCin.data.dtNasc.substring(
					4,
					6,
				)}/${consultarCin.data.dtNasc
					.substring(0, 4)
					.trim()} - Filiação 2: ${letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
					consultarCin.data.nomeMae,
				)
					.toUpperCase()
					.trim()}`;

				if (hasDataRFBDivergences || hasCPFDivergences) {
					if (hasDataRFBDivergences) {
						editedRfbData = dadosRfb;
					}
					if (hasCPFDivergences) {
						const descricaoSituacao = getDescricaoSituationCin(
							consultarCin.data.codSitCad,
						);

						editedRfbData =
							`${editedRfbData && `${editedRfbData} - `}` +
							`CPF: ${consultarCin.data.codSitCad} - ${descricaoSituacao}`;
					}

					setRfbDivergenceData({
						data: editedRfbData,
						resultValidations: {
							nameValidation,
							motherNameValidation,
							birthDayValidation,
						},
					});

					if (isPrimeiraViaFlow && isUploadFlow) {
						dispatch(
							consultarProcessoRequest(token, {
								cpfCidadao:
									formValues?.cpf.replace('-', '').replaceAll('.', '') || '',
							}),
						);
					} else {
						const messageContent = gerarMensagemValidacao(
							nameValidation,
							motherNameValidation,
							birthDayValidation,
							uploadRenderContent,
							hasCPFDivergences,
						);
						displayConfirmModal(messageContent, editedRfbData);
					}
				}
			}
		} else if (
			consultarCin.instanceRequest === 'cadastro-rg' &&
			consultarCin.status === 204 &&
			!consultarCin.cpfResponsavel
		) {
			const cpfValue =
				formValues?.cpf.replace('-', '').replaceAll('.', '') || '';
			addNotifications({
				errors: [`CPF ${cpfValue} não cadastrado`],
				notificationOrigin: 'SERVICE_SGU',
			});
		} else if (
			consultarCin.instanceRequest === 'cadastro-rg' &&
			consultarCin.status === 400 &&
			!consultarCin.cpfResponsavel
		) {
			if (caller2 > 3) {
				const payload: IncluirRequest = {
					descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
					tipoDocumento: 'RG',
					numeroDocumento: formValues?.numeroRg ?? '',
					codigoLocalidade: Number(login.user.posto),
					idOrgao: login.user.idOrgao,
					cpf: login.user.cpf,
					descricaoServico: 'ATENDIMENTO_CIN',
					flagConfronto: 'N',
					idMotivo: 16,
					numeroProcesso: atendimento.salvarAtendimento.data?.idAtendimento,
					observacao: `${
						consultarCin.dataError?.mensagem || 'Erro no servico consultarCin'
					}`,
				};
				dispatch(estatisticaIncluirRequest(token, payload));
				addNotifications({
					errors: [
						'Problemas na conexão com Receita Federal. Tente Novamente.',
					],
					notificationOrigin: 'SERVICE_SGU',
				});
			} else if (formValues?.cpf) {
				setCaller2(caller2 + 1);
				dispatch(
					consultarCpfCinRequest(
						token,
						formValues.cpf.replace('-', '').replaceAll('.', ''),
						false,
						'cadastro-rg',
					),
				);
			}
		} else if (
			consultarCin.instanceRequest === 'cadastro-rg' &&
			consultarCin.status !== 0 &&
			consultarCin.data &&
			formValues &&
			consultarCin.data.cpfId === limparMascara(formValues.cpf)
		) {
			const payload: IncluirRequest = {
				descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
				tipoDocumento: 'RG',
				numeroDocumento: formValues?.numeroRg ?? '',
				codigoLocalidade: Number(login.user.posto),
				idOrgao: login.user.idOrgao,
				cpf: login.user.cpf,
				descricaoServico: 'ATENDIMENTO_CIN',
				flagConfronto: 'N',
				idMotivo: 16,
				numeroProcesso: atendimento.salvarAtendimento.data?.idAtendimento,
				observacao: `Erro no servico consultarCin`,
			};
			dispatch(estatisticaIncluirRequest(token, payload));
			setErroCIN(true);
			const nonSpProcess = consultarProcesso.data?.find(
				item => item.ufEmissao !== 'SP',
			);
			const uf = nonSpProcess?.ufEmissao || 'UF desconhecida';
			addNotifications({
				errors: [`${CINValidationMessages.ufDifferentSP} - ${uf}.`],
				notificationOrigin: 'SERVICE_SGU',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		consultarCin.data,
		consultarCin.dataError,
		consultarCin.status,
		dispatch,
	]);

	useEffect(() => {
		if (
			consultarCpfCinResponsavel.instanceRequest === 'cadastro-rg' &&
			consultarCpfCinResponsavel.status === 204 &&
			formValues
		) {
			setCheckResponsavel(false);
			const cpfValue =
				formValues?.cpfResponsavel.replace('-', '').replaceAll('.', '') || '';
			addNotifications({
				errors: [`CPF Responsável ${cpfValue} não cadastrado`],
				notificationOrigin: 'SERVICE_SGU',
			});
		} else if (
			consultarCpfCinResponsavel.instanceRequest === 'cadastro-rg' &&
			consultarCpfCinResponsavel.status === 400 &&
			consultarCpfCinResponsavel.data &&
			formValues &&
			consultarCpfCinResponsavel.data.cpfId === limparMascara(formValues.cpf)
		) {
			const payload: IncluirRequest = {
				descricaoSistemaOrigem: 'BALCÃO ÚNICO 4.0',
				tipoDocumento: 'RG',
				numeroDocumento: formValues?.numeroRg ?? '',
				codigoLocalidade: Number(login.user.posto),
				idOrgao: login.user.idOrgao,
				cpf: login.user.cpf,
				descricaoServico: 'ATENDIMENTO_CIN',
				flagConfronto: 'N',
				idMotivo: 16,
				numeroProcesso: atendimento.salvarAtendimento.data?.idAtendimento,
				observacao: `Erro no servico consultarCin`,
			};
			dispatch(estatisticaIncluirRequest(token, payload));
			setErroCIN(true);
			const nonSpProcess = consultarProcesso.data?.find(
				item => item.ufEmissao !== 'SP',
			);
			const uf = nonSpProcess?.ufEmissao || 'UF desconhecida';
			addNotifications({
				errors: [`${CINValidationMessages.ufDifferentSP} - ${uf}.`],
				notificationOrigin: 'SERVICE_SGU',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		consultarCpfCinResponsavel.dataError,
		consultarCpfCinResponsavel.status,
		dispatch,
	]);

	const handleConfirmacoesModal = useCallback(
		(values: IFormCadastroRg) => {
			const inscricaoCpf = login.user.parametrosLocalidade.find(
				parametro => parametro.sigla === 'INSCRICAO_CPF',
			);

			const inscricaoCpfSegundaVia = login.user.parametrosLocalidade.find(
				parametro => parametro.sigla === 'INSCRICAO_CPF_SEG_VIA',
			);

			if (
				((primeiraVia && inscricaoCpf && inscricaoCpf.valor === 'TRUE') ||
					(segundaVia &&
						inscricaoCpfSegundaVia &&
						inscricaoCpfSegundaVia.valor === 'TRUE')) &&
				values.inscricaoCpf === '' &&
				values.cpf.length === 0
			) {
				setModalInscricaoCpf(true);
				return;
			}

			if (
				cadastroRg.tipo.segundaVia &&
				!cadastroRg.config?.acervo &&
				consultaPesquisaCidadao.selecionado?.afis === '*' &&
				values.dni !== '10977'
			) {
				setModalAtendimento(true);
				return;
			}

			values.dni === '10977' ? validaCin(values) : submitForm(values);
		},
		[
			cadastroRg.config,
			cadastroRg.tipo.segundaVia,
			consultaPesquisaCidadao.selecionado,
			login.user.parametrosLocalidade,
			primeiraVia,
			segundaVia,
			submitForm,
			validaCin,
		],
	);

	const buscarMunicipioTrabalho = useCallback(
		async (values: IFormCadastroRg) => {
			const id = limparMascara(values.codigoMunicipioTrabalho).slice(0, 5);
			if (id !== '') {
				const response: any = await getApiIntegrador(
					token || '',
					`naturalidades`,
					{
						id,
					},
				);

				if (response.status === 200) {
					const naturalidade: Naturalidade = response.data[0];

					if (!naturalidade.ibge || naturalidade.ibge.idIbge === 0) {
						addNotifications({
							errors: [
								'Município de trabalho do cidadão Inválido - Município não registrado no IBGE. Consulte o Supervisor!',
							],
						});

						return;
					}
					setFormValues(values);
					handleConfirmacoesModal(values);
				} else {
					addNotifications({
						errors: [
							'Serviço indisponível ou erro de conexão. Entre em contato com o suporte.',
						],
					});
				}
			}
		},
		[handleConfirmacoesModal, token],
	);

	const buscarMunicipioResidencia = useCallback(
		async (values: IFormCadastroRg) => {
			const id = limparMascara(values.codigoMunicipioResidencia).slice(0, 5);
			if (id !== '') {
				const response: any = await getApiIntegrador(
					token || '',
					`naturalidades`,
					{
						id,
					},
				);

				if (response.status === 200) {
					const naturalidade = response.data[0];

					if (!naturalidade.ibge || naturalidade.ibge.idIbge === 0) {
						addNotifications({
							errors: [
								'Município de residência do cidadão Inválido - Município não registrado no IBGE. Consulte o Supervisor!',
							],
						});

						return;
					}
					if (values.codigoMunicipioTrabalho !== '') {
						buscarMunicipioTrabalho(values);
					} else {
						setFormValues(values);
						handleConfirmacoesModal(values);
					}
				} else {
					addNotifications({
						errors: [
							'Serviço indisponível ou erro de conexão. Entre em contato com o suporte.',
						],
					});
				}
			}
		},
		[buscarMunicipioTrabalho, handleConfirmacoesModal, token],
	);

	const buscarNaturalidade = useCallback(
		async (values: IFormCadastroRg) => {
			const id = limparMascara(values.codigoNaturalidade).slice(0, 5);
			if (id !== '') {
				const response: any = await getApiIntegrador(
					token || '',
					`naturalidades`,
					{
						id,
					},
				);

				if (response.status === 200) {
					const naturalidade = response.data[0];

					if (
						(values.codigoNaturalidade.slice(0, 7) !== '99000-2' ||
							values.codigoNaturalidade.slice(0, 5) !== '99000' ||
							values.dni === '10977') &&
						(!naturalidade.ibge || naturalidade.ibge.idIbge === 0) &&
						!(
							values.dbas === 'NL' ||
							values.dbas === 'NZ' ||
							values.dbas === 'TI' ||
							values.dbas === 'TN' ||
							(values.dbas === 'CN' &&
								values.livro[0] &&
								values.livro[0].toUpperCase() === 'K') ||
							(values.dbas === 'CN' &&
								values.livro[0] &&
								values.livro[0].toUpperCase() === 'Y') ||
							(values.dbas === 'CN' &&
								values.livro[0] &&
								values.livro[0].toUpperCase() === 'X') ||
							(values.dbas === 'CN' &&
								values.livro[0] &&
								values.livro[0].toUpperCase() === 'E') ||
							(values.dbas === 'CC' &&
								values.livro[0] &&
								values.livro[0].toUpperCase() === 'T') ||
							(values.dbas === 'CC' &&
								values.livro[0] &&
								values.livro[0].toUpperCase() === 'W')
						) &&
						values.dni === '10977'
					) {
						addNotifications({
							errors: [
								'Naturalidade do cidadão Inválida - Município não registrado no IBGE. Consulte o Supervisor!',
							],
						});

						return;
					}
					buscarMunicipioResidencia(values);
				} else {
					addNotifications({
						errors: [
							'Serviço indisponível ou erro de conexão. Entre em contato com o suporte.',
						],
					});
				}
			}
		},
		[buscarMunicipioResidencia, token],
	);

	const handleSubmit = useCallback(
		(values: IFormCadastroRg) => {
			setTimeout(() => {
				if (values.nomeMae === values.nome) {
					Modal.confirm({
						title:
							'A filiação 2 foi cadastrada idêntica ao nome do(a) cidadão(ã). Confirma que o cadastro está correto?',
						okText: 'Sim',
						cancelText: 'Não',
						onOk() {
							buscarNaturalidade(values);
						},
						onCancel() {},
					});
				} else if (values.nomePai === values.nome) {
					Modal.confirm({
						title:
							'A filiação 1 foi cadastrada idêntica ao nome do(a) cidadão(ã). Confirma que o cadastro está correto?',
						okText: 'Sim',
						cancelText: 'Não',
						onOk() {
							buscarNaturalidade(values);
						},
						onCancel() {},
					});
				} else {
					buscarNaturalidade(values);
				}
			}, 200);
		},
		[buscarNaturalidade],
	);

	const handleButtonVoltar = useCallback(() => {
		dispatch(clearNotifications());
		dispatch(cadastroRgClear());
		dispatch(consultarCpfCinClear());
		dispatch(capturarBiometriaClearLeitura());
		dispatch(consultaPesquisaCidadaoClear());
		dispatch(consultaPesquisaCriminalClear());
		dispatch(consultaPesquisaObservacaoClear());
		dispatch(gerarDareClear());
		dispatch(disponibilzarDareClear());
		dispatch(consultarCpfClear());
		dispatch(consultaCpfClear());
		dispatch(consultarCpfCinResponsavelClear());

		history.push(ROUTE_IIRGD_PESQUISAR_RG);
	}, [dispatch, history]);

	useEffect(() => {
		setTimeout(() => {
			if (location.pathname === '/iirgd/rg-fic-digital/cadastro') {
				if (
					primeiraVia ||
					(!primeiraVia && !reusoParcial && !reusoTotal && !segundaVia)
				) {
					dispatch(
						setBreadcrumb(
							[
								{ name: 'IIRGD', route: '/iirgd' },
								{ name: 'Cadastrar Carteira de Identidade 1ª via OBS' },
							],
							true,
						),
					);
				} else {
					dispatch(
						setBreadcrumb(
							[
								{ name: 'IIRGD', route: '/iirgd' },
								{ name: 'Cadastrar Carteira de Identidade' },
							],
							true,
						),
					);
				}
			}
		}, 100);
	}, [
		dispatch,
		location.pathname,
		primeiraVia,
		reusoParcial,
		reusoTotal,
		segundaVia,
	]);

	useEffect(() => {
		if (
			modalInstanceRef.current &&
			baixarArquivos.instanceRequest &&
			baixarArquivos.instanceRequest === 'arquivoIirgd' &&
			baixarArquivos.base64
		) {
			(modalInstanceRef.current as any).destroy();
			modalInstanceRef.current = null;
		}
	}, [modalInstanceRef, baixarArquivos]);

	return (
		<>
			<Formik
				validateOnChange={false}
				validateOnBlur={notifications.errors.length > 0}
				initialValues={formInitialValues}
				validate={handleValidate}
				onSubmit={handleSubmit}
				enableReinitialize
			>
				{formik => (
					<Form autoComplete="off">
						{hasLoaded && (
							<>
								<Section title={appTitle}>
									<Principal
										formik={formik}
										bloqueioPortaria606={bloqueioPortaria606}
										erroCIN={erroCIN}
									/>

									<DocumentoApresentado
										formik={formik}
										bloqueioPortaria606={bloqueioPortaria606}
									/>

									<DadosAdicionaisCidadao
										formik={formik}
										bloqueioPortaria606={bloqueioPortaria606}
									/>

									<DadosAdicionaisTrabalho formik={formik} />

									<DadosAdicionaisContato formik={formik} />

									<InfosAdicionais formik={formik} />

									<DadosAdicionaisRG formik={formik} />

									<EntregaRG formik={formik} />

									<Row gutter={[0, 10]} justify="center">
										<Col>
											<ButtonImage
												type="submit"
												src="avancar"
												onClick={() => {
													dispatch(clearNotifications());
												}}
												disabled={
													cadastroRg.atualizarRgSuccess ||
													cadastroRg.cadastrarRgSuccess
												}
											/>
										</Col>
									</Row>
								</Section>

								<ButtonVoltar navigate={false} onClick={handleButtonVoltar} />
							</>
						)}
					</Form>
				)}
			</Formik>

			<SolicitarInscricaoCPF
				showModal={modalInscricaoCpf}
				onOk={() => {
					setModalInscricaoCpf(false);

					if (formValues !== null) {
						const returnValue = {
							...formValues,
							inscricaoCpf: 'false',
						};
						returnValue.dni === '10977'
							? validaCin(returnValue)
							: submitForm(returnValue);

						return;
					}

					if (!cadastroRg.config?.acervo) {
						setModalAtendimento(true);
					}
				}}
				onCancel={() => {
					setModalInscricaoCpf(false);
				}}
			/>

			<ConfirmacaoAtendimento
				showModal={modalAtendimento}
				response={res => {
					dispatch(cadastroRgConfirmacaoAtendimento(res));
					setModalAtendimento(false);

					if (formValues) {
						formValues.dni === '10977'
							? validaCin(formValues)
							: submitForm(formValues);
					}
				}}
			/>

			{baixarArquivos.instanceRequest &&
				baixarArquivos.instanceRequest === 'arquivoIirgd' &&
				baixarArquivos.base64 && (
					<PDFViewer
						title="Visualizar Arquivo (Apenas PDF)"
						source={baixarArquivos.base64}
						onClose={() => {
							dispatch(baixarArquivosClear());

							if (consultarCin && consultarCin.data) {
								const nameValidation =
									letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
										consultarCin.data.nomeContribuinte,
									)
										.toUpperCase()
										.trim() ===
									letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
										formValues?.nome || '',
									)
										.toUpperCase()
										.trim();

								let maeCIN =
									letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
										consultarCin.data.nomeMae,
									)
										.toUpperCase()
										.trim();

								if (
									maeCIN === 'MAE DESCONHECIDA' ||
									maeCIN === 'NC' ||
									maeCIN === ''
								) {
									maeCIN = 'NC';
								}

								const motherNameValidation =
									maeCIN ===
									letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
										formValues?.nomeMae || '',
									)
										.toUpperCase()
										.trim();

								const birthDayValidation =
									`${consultarCin.data.dtNasc.substring(
										0,
										4,
									)}-${consultarCin.data.dtNasc.substring(
										4,
										6,
									)}-${consultarCin.data.dtNasc.substring(6, 8)}`.replaceAll(
										/\s\s+/g,
										' ',
									) === unformatDate(formValues?.dataNascimento).trim();

								const messageContent = gerarMensagemValidacao(
									nameValidation,
									motherNameValidation,
									birthDayValidation,
									uploadRenderContent,
								);

								const dadosRfb = `Nome: ${letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
									consultarCin.data.nomeContribuinte,
								)
									.toUpperCase()
									.trim()} - Data nascimento: ${consultarCin.data.dtNasc.substring(
									6,
									8,
								)}/${consultarCin.data.dtNasc.substring(
									4,
									6,
								)}/${consultarCin.data.dtNasc
									.substring(0, 4)
									.trim()} Filiação 2: ${letrasRemoveApostrofoAcentoGraveAgudoDuploEspacoCedilhaAcentos(
									consultarCin.data.nomeMae,
								)
									.toUpperCase()
									.trim()}`;

								displayConfirmModal(messageContent, dadosRfb);
							}
						}}
					/>
				)}
		</>
	);
};

export default CadastroRG;
